/* eslint-disable max-len */
import React from "react"
import Icon from "@ant-design/icons"

const DotSvg = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="6" fill="currentColor" />
  </svg>
)

const DotIcon = (props) => <Icon component={DotSvg} {...props} />

export { DotIcon }
